import SessionValidation from "./common/sessionValidation";
import LayoutComponent from "./layout";
import CommonLayout from "./commonLayout/commonLayout";
import DepartmentPriceList from "./departmentPriceList/departmentPriceList";
import AddDepartmentPrice from "./addDepartmentPrice/addDepartmentPrice";
import EditDepartmentPrice from "./editDepartmentPrice/editDepartmentPrice";
import PriceList from "./departmentPriceList/priceList";
import PatientProfileList from "./patientProfileList/patientProfileList";
import PatientFullView from "./patientFullView/patientFullView";
import DoctorSpecialization from "./doctorSpecialization/doctorSpecialization";
import AddSpeciality from "./doctorSpecialization/addSpeciality";
import EditDepartment from "./doctorSpecialization/editDepartment";
import Verification from "./verification/verification";
import VerifyPersonalInfo from "./verifyPersonalInfo/verifyPersonalInfo";
import PersonalInfo from "./personalInfo/personalInfo";
import PatientAddress from "./patientAddress/patientAddress";
import PatientNationalId from "./patientNationalId/patientNationalId";
import PatientInsurance from "./patientInsurance/patientInsurance";
import GenerateHn from "./generateHn/generateHn";
import editPersonalInfo from "./EditVerificationRequest/editPersonalInfo";
import ManageAmbulanceList from "./manageAmbulances/manageAmbulanceList/ManageAmbulanceList";
import ManageDriverProfile from "./manageDriver/manageDriverProfile/ManageDriverProfile";
import ManageDriverList from "./manageDriver/manageDriverList/ManageDriverList";
import ViewAmbulance from "./manageAmbulances/viewAmbulance/ViewAmbulance";
import OnboardAmbulance from "./manageAmbulances/onboardAmbulance/OnboardAmbulance";
import ManageNurseRequest from "./nursingCare/manageNurseRequest/manageNurseRequest/ManageNurseRequest";
import ServiceDetails from "./nursingCare/manageNurseRequest/serviceDetails/ServiceDetails";
import PatientDetails from "./nursingCare/manageNurseRequest/patientDetails/PatientDetails";
import ArticleList from "./HealthArticle/ArticleList/ArticleList";
import AddArticle from "./HealthArticle/AddArticle/AddArticle";
import AddNationalIdList from "./nationalIdentity/AddNationalIdList/AddNationalIdList";
import NationalIdList from "./nationalIdentity/NationalIdList/NationalIdList";
import EditArticle from "./HealthArticle/EditArticle/EditArticle";
import VerifyInsurance from "./EditVerificationRequest/verifyPatientInsurance";
import ViewTermsCondition from "./TermsCondition/ViewTermsCondition/ViewTermsCondition";
import EditTermsCondition from "./TermsCondition/EditTermsCondition/EditTermsCondition";
import ListTermsCondition from "./TermsCondition/ListTermsCondition/ListTermsCondition";
import AdditionalConsumableList from "./nursingCare/ManageResource/AdditionalConsumableList/AdditionalConsumableList";
import CreateConsumableList from "./nursingCare/ManageResource/CreateConsumable/CreateConsumable";
import ManageServicesList from "./nursingCare/ManageService/ManageServiceList/ManageServicesList";
import CreateServiceMain from "./nursingCare/ManageService/CreateService/CreateServiceMain";
import ManageRequestServiceDetails from "./nursingCare/ManageService/ServicesDetail/MamangeRequestServicesDetails";
import EditConsumable from "./nursingCare/ManageResource/EditConsumable/EditConsumable";
import CreateNurse from "./nursingCare/ManageNurse/CreateNurse/CreateNurse";
import NurseList from "./nursingCare/ManageNurse/NurseList/NurseList";
import EditNurse from "./nursingCare/ManageNurse/EditNurse/EditNurse";

const Component = {
  SessionValidation,
  AddNationalIdList,
  NationalIdList,
  LayoutComponent,
  CommonLayout,
  DepartmentPriceList,
  AddDepartmentPrice,
  EditDepartmentPrice,
  PriceList,
  PatientProfileList,
  PatientFullView,
  DoctorSpecialization,
  AddSpeciality,
  EditDepartment,
  Verification,
  VerifyPersonalInfo,
  PersonalInfo,
  PatientAddress,
  PatientNationalId,
  PatientInsurance,
  GenerateHn,
  editPersonalInfo,
  VerifyInsurance,
  ManageAmbulanceList,
  ManageDriverProfile,
  ManageDriverList,
  ViewAmbulance,
  OnboardAmbulance,
  ManageNurseRequest,
  AdditionalConsumableList,
  CreateConsumableList,
  EditConsumable,
  CreateNurse,
  NurseList,
  EditNurse,
  ServiceDetails,
  PatientDetails,
  ArticleList,
  AddArticle,
  EditArticle,
  ViewTermsCondition,
  EditTermsCondition,
  ListTermsCondition,
  ManageServicesList,
  CreateServiceMain,
  ManageRequestServiceDetails,
};

export default Component;
